import { spotsService } from './service'
import { createFetchHook } from '../../acato-utils'

export const spotServiceHooks = createFetchHook(spotsService)
